<template>
    <div class="position-relative">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div
                        ref="slider__controls"
                        class="slider__controls"
                        aria-label="Theme slider"
                        tabindex="0"
                    >
                        <a
                            class="prev"
                            aria-controls="customize"
                            data-controls="prev"
                            tabindex="-1"
                            ><i class="fa fa-arrow-left" aria-hidden="true"></i
                        ></a>
                        <a
                            class="next"
                            aria-controls="customize"
                            data-controls="next"
                            tabindex="-1"
                            ><i class="fa fa-arrow-right" aria-hidden="true"></i
                        ></a>
                    </div>
                </div>
            </div>
        </div>
        <div ref="slider" class="theme-slider">
            <section
                v-for="(theme, index) in themes"
                :key="index"
                :class="'slide__' + theme.className"
                class="position-relative"
            >
                <theme-icons :classname="theme.className"></theme-icons>
                <div class="container position-relative">
                    <div class="row">
                        <div class="col-12 col-md-7">
                            <h2 class="h1 mb-3">{{ theme.title }}</h2>
                            <div
                                class="ml-md-2 mb-5"
                                v-html="theme.intro"
                            ></div>
                            <a
                                v-if="theme.button != undefined"
                                :href="theme.button.Url"
                                :target="theme.button.Target"
                                :class="'btn--' + theme.className"
                                class="btn ml-md-2"
                                ><span
                                    >{{ theme.button.Name }}
                                    <i
                                        class="fa fa-arrow-right ml-2"
                                        aria-hidden="true"
                                    ></i
                                ></span>

                                ></a
                            >
                        </div>
                        <div class="col-12 col-md-6 offset-md-6">
                            <div
                                class="theme-activity"
                                :class="'bg--' + theme.className"
                            >
                                <div class="theme-activity__content">
                                    <img
                                        v-lazy="
                                            $useWebP
                                                ? theme.imageSrcWebP
                                                : theme.imageSrc
                                        "
                                        :alt="theme.imageAlt"
                                    />
                                    <h3 class="h5 mb-0 ml-md-2">
                                        {{ theme.imageTitle }}
                                    </h3>
                                    <p class="mb-0 ml-md-2">
                                        {{ theme.imageSubtitle }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';
import themeIcons from '@/components/blocks/theme-icons';

export default {
    components: {
        themeIcons
    },
    props: {
        slides: {
            type: Number,
            default: 1
        },
        themes: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            slider: '',
            imageUrl: ''
        };
    },

    mounted() {
        this.$nextTick(() => {
            this.initSlider();
        });
    },

    methods: {
        initSlider() {
            this.slider = tns({
                container: this.$refs.slider,
                items: 1,
                controlsContainer: this.$refs.slider__controls,
                slideBy: 1,
                mouseDrag: false,
                swipeAngle: false,
                lazyload: false,
                nav: false,
                autoplayButton: false,
                autoplayButtonOutput: false,
                preventScrollOnTouch: 'auto',
                speed: 400
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.slider__controls {
    position: absolute;
    right: 15px;
    top: 30px;
    height: auto;
    box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.08);
    z-index: 10;
    border-radius: 7px;
    background-color: $white;

    @include media-breakpoint-up(md) {
        top: 100px;
    }
}

.slider__controls a:not([href]) {
    padding: 2px 32px;
    width: 50%;
    float: left;
    font-size: 16px;
    color: $purple-1;
    cursor: pointer;

    @include media-breakpoint-up(md) {
        padding: 12px 32px;
        font-size: 30px;
    }
}

.slider__controls i {
    position: relative;
    transition: 0.15s left ease-in-out, 0.15s right ease-in-out;
}

.slider__controls .prev i {
    left: 0;
}

.slider__controls .next i {
    right: 0;
}

.slider__controls .prev:hover i {
    left: -10px;
}

.slider__controls .next:hover i {
    right: -10px;
}

.slider__controls a.prev:after {
    content: '';
    height: 70%;
    border-right: 1px solid $gray-3;
    right: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}
</style>

<style lang="scss">
.theme-slider section {
    padding: 100px 0 0 0;

    @include media-breakpoint-up(lg) {
        padding: 130px 0 0 0;
    }
}

.theme-activity {
    background-color: $orange;
    border-radius: 21px;
    padding: 0 30px 5px 30px;
    position: relative;
    height: calc(100% - 120px);
    top: 160px;

    @include media-breakpoint-up(md) {
        top: 0;
    }
}

.theme-activity:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 90px;
    top: 60px;
    left: 0;
    border-radius: 50%;

    .slide__science & {
        box-shadow: 0 -90px 0px 0px $science;
    }

    .slide__culture & {
        box-shadow: 0 -90px 0px 0px $culture;
    }

    .slide__nature & {
        box-shadow: 0 -90px 0px 0px $nature;
    }

    .slide__dance & {
        box-shadow: 0 -90px 0px 0px $dance;
    }

    .slide__expedition & {
        box-shadow: 0 -90px 0px 0px $expedition;
    }

    .slide__technology & {
        box-shadow: 0 -90px 0px 0px $technology;
    }
}

.theme-activity__content {
    position: relative;
    top: -120px;
    color: $white;

    h3 {
        font-size: 1.25rem;
    }

    p {
        font-size: 1rem;
    }
}

.theme-activity img {
    width: 100%;
    display: block;
    margin: 0 auto 10px 0;
}
</style>
